import { module } from "angular";
import { ProfileComponent } from "./ProfileComponent";

module("mmAuth").component("mmProfile", new ProfileComponent());
